import { atom } from 'jotai';

export const chatUnseenCountsAtom = atom({});

export const totalChatUnreadAtom = atom((get) =>
  Object.values(get(chatUnseenCountsAtom)).reduce((sum, c) => sum + c, 0)
);

export const chatLastMessageAtom = atom({});